import Barcode from "./pages/OnBoard";
import Layout from "./Layout";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RouteGuard from "./components/RouteGuard";
import {
  Overview,
  Statementofaccounts,
  EODclosing,
  CardsSettings,
  CardTransactions,
  Banktransfers,
  Suyooltosuyool,
  Exchange,
  Merchantinformation,
  Branches,
  BranchDetails,
  Employees,
  EditBranchTemplate,
  Enrollment,
  PaymentRequest
} from "./pages";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Barcode />} />
        <Route path='Overview' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Overview />} />
        </Route>
        <Route path='statementofaccount' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Statementofaccounts />} />
        </Route>
        <Route path='eodclosing' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<EODclosing />} />
        </Route>
        <Route path='banktransfers' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Banktransfers />} />
        </Route>
        <Route path='cardssettings' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<CardsSettings />} />
        </Route>
        <Route path='cardtransactions/:cardId?' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<CardTransactions />} />
        </Route>
        <Route path='banktransfers' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Banktransfers />} />
        </Route>

        <Route path='suyooltosuyool' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Suyooltosuyool />} />
        </Route>
        <Route path='exchange' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Exchange />} />
        </Route>
        {/*<Route path='cashdelivery' element={<RouteGuard children={<Layout />} />}>*/}
        {/*  <Route index element={<Cashdelivery />} />*/}
        {/*</Route>*/}
        {/*<Route path='standingorder' element={<RouteGuard children={<Layout />} />}>*/}
        {/*  <Route index element={<Standingorder />} />*/}
        {/*</Route>*/}
        {/*<Route path='exportedreports' element={<RouteGuard children={<Layout />} />}>*/}
        {/*  <Route index element={<Exportedreports />} />*/}
        {/*</Route>*/}
        <Route path='merchantinformation' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Merchantinformation />} />
        </Route>
        <Route path='branches' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Branches />} />
          <Route path=':BranchID' element={<BranchDetails />} />
          <Route path='edit/:BranchID' element={<EditBranchTemplate />} />
        </Route>
        {/* <Route path='cashmanagement' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Cashmanagement />} />
        </Route> */}
        <Route path='employees' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<Employees />} />
        </Route>
        <Route path='enrollment' element={<Enrollment entity="legal"/>} />
        <Route path='merchant-enrollment/:step' element={<Enrollment entity="merchant"/>} />
        <Route path='paymentrequest' element={<RouteGuard children={<Layout />} />}>
          <Route index element={<PaymentRequest />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;